const Hero = ({ title, subtitle, ctaText, ctaLink, onCtaClick }) => {
  return (
    <div className="bg-gradient-to-br from-[#1e3a5f] to-[#2d5380] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="text-center max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="text-xl md:text-2xl text-gray-200 mb-8">
              {subtitle}
            </p>
          )}
          {ctaText && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              {onCtaClick ? (
                <button
                  onClick={onCtaClick}
                  className="bg-white text-[#1e3a5f] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors text-lg"
                >
                  {ctaText}
                </button>
              ) : (
                <a
                  href={ctaLink}
                  className="bg-white text-[#1e3a5f] px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors text-lg inline-block"
                >
                  {ctaText}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Hero;